import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
import { statusMeta } from "@/lib/format";

const ORDER = [
  "feedback_logged",
  "entry_requested",
  "entry_approved",
  "plan_submitted",
  "plan_active",
  "in_checkins",
  "decision_pending",
  "closed",
];

// map any status to an index; rejections fold back to their request stage
const INDEX = {
  feedback_logged: 0,
  entry_requested: 1,
  entry_rejected: 1,
  entry_approved: 2,
  plan_submitted: 3,
  plan_rejected: 3,
  plan_active: 4,
  in_checkins: 5,
  decision_pending: 6,
  closed: 7,
};

export function StagePipeline({ status }) {
  const current = INDEX[status] ?? 0;
  const steps = [
    { k: "feedback_logged", label: "Feedback" },
    { k: "entry_requested", label: "Entry req." },
    { k: "entry_approved", label: "Entry ok" },
    { k: "plan_submitted", label: "Plan sub." },
    { k: "plan_active", label: "Plan active" },
    { k: "in_checkins", label: "Check-ins" },
    { k: "decision_pending", label: "Decision" },
    { k: "closed", label: "Closed" },
  ];
  return (
    <div className="flex flex-wrap items-center gap-y-3" data-testid="stage-pipeline">
      {steps.map((s, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <div key={s.k} className="flex items-center">
            <div className="flex flex-col items-center gap-1.5 w-[70px] sm:w-[84px]">
              <div
                className={cn(
                  "h-8 w-8 rounded-full flex items-center justify-center text-xs font-semibold transition-colors",
                  done && "bg-patria-green text-patria-surface",
                  active && "bg-patria-terracotta text-patria-surface ring-4 ring-patria-terracotta/20",
                  !done && !active && "bg-patria-sage text-patria-muted ring-1 ring-patria-muted/20"
                )}
              >
                {done ? <Check className="h-4 w-4" /> : i + 1}
              </div>
              <span className={cn("text-[10px] sm:text-xs text-center leading-tight", active ? "text-patria-ink font-medium" : "text-patria-muted")}>
                {s.label}
              </span>
            </div>
            {i < steps.length - 1 && (
              <div className={cn("h-0.5 w-4 sm:w-6 -mt-5", i < current ? "bg-patria-green" : "bg-patria-muted/25")} />
            )}
          </div>
        );
      })}
    </div>
  );
}
